import styles from "@styles/components/si-input/index.module.scss";
import React from "react";

export interface InputProps {
    children?: React.ReactNode;
    props?: any;
    inputclass?: string;
    labelclass?: string;
    id?: string
    placeholder?: string
    label?: string
    type?: string
    onChange?: any
    value?: any
}

const SIInput: React.FC<InputProps> = ({children, ...props}) => {
    return (
        <div className={styles.input_container}>
            {
                props.label &&
                <label id={props.id} htmlFor={props.id} className={`${props.inputclass ? props.inputclass : ''}`}>{props.label}</label>
            }
            <input id={props.id} type={props.type} className={`${props.inputclass ? props.inputclass : ''}`} {...props}  value={props.value} onChange={props.onChange}
                   placeholder={props.placeholder}>
                {children}
            </input>
        </div>

    );
};
export default SIInput;
